import { render, staticRenderFns } from "./AllChecklists.vue?vue&type=template&id=4a12cc3c&"
import script from "./AllChecklists.vue?vue&type=script&lang=js&"
export * from "./AllChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports